"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_portal_1 = require("react-portal");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const cw_parameters_provider_1 = require("@dialogexe/cw-parameters-provider");
class Header extends React.Component {
    constructor(props) {
        super(props);
        this.defaultOffsetTop = 30;
        this.menuLink = 'menu-link';
        this.componentDidMount = () => {
            if (typeof window !== 'undefined' && window.document) {
                document.addEventListener('mousedown', this.handleClickOutside);
                window.addEventListener('resize', this.onResizeWindow);
            }
            const filmGrailConfig = cw_parameters_provider_1.parametersProvider.get('api.filmgrailPartners');
            const partnersWithFilmGrail = filmGrailConfig.split(",");
            const currentPartnerId = this.props.partners[0];
            if (partnersWithFilmGrail.indexOf(currentPartnerId.toString()) > -1) {
                this.setState({ partnerSupportsFilmGrail: true });
            }
            this.showHumbergerIcon();
        };
        this.componentWillUnmount = () => {
            if (typeof window !== 'undefined' && window.document) {
                document.removeEventListener('mousedown', this.handleClickOutside);
                window.removeEventListener('resize', this.onResizeWindow);
            }
        };
        this.onResizeWindow = () => {
            return this.showHumbergerIcon();
        };
        this.getYvalues = () => {
            const anchorYvalues = this.getYvaluesOfElement("a");
            const listItemYvalues = this.getYvaluesOfElement("li");
            return [...anchorYvalues, ...listItemYvalues];
        };
        this.getYvaluesOfElement = (element) => {
            let yValues = [];
            const anchor = document.getElementById("menu-items").getElementsByTagName(element);
            for (let el of anchor) {
                const rect = el.getClientRects();
                if (rect) {
                    const data = rect[0];
                    if (data) {
                        yValues = [...yValues, data.y];
                    }
                }
            }
            return yValues;
        };
        this.showHumbergerIcon = () => {
            if (this.hasSameYaxis()) {
                if (this.state.showHumbergerIcon) {
                    this.setState({ showHumbergerIcon: false });
                }
            }
            else {
                if (!this.state.showHumbergerIcon) {
                    this.setState({ showHumbergerIcon: true });
                }
            }
        };
        this.hasSameYaxis = () => {
            const yValues = this.getYvalues();
            return new Set(yValues).size == 1;
        };
        this.handleClickOutside = (event) => {
            if (event.target !== this.state.portal && event.target.className !== this.menuLink)
                this.setState({
                    dropdownOpen: []
                });
        };
        this.toggleMenu = () => {
            this.setState((prevState) => ({
                menuOpen: !prevState.menuOpen
            }));
        };
        this.toggleSearch = () => {
            this.setState((prevState) => ({
                searchOpen: !prevState.searchOpen
            }));
        };
        this.openDropdown = (e, menuItem) => {
            const { dropdownOpen } = this.state;
            if (dropdownOpen.indexOf(menuItem.id) !== -1) {
                return this.closeDropdown(menuItem.id);
            }
            let element;
            if (typeof window !== 'undefined' && window.document) {
                element = menuItem.parent && window.document.getElementById(menuItem.id);
            }
            this.setState({
                dropdownOpen: this.state.dropdownOpen.indexOf(menuItem.id) === -1 && this.hasChildren(menuItem.id)
                    ? [...this.state.dropdownOpen, menuItem.id]
                    : this.state.dropdownOpen,
                portal: e.target,
                top: element ? element.offsetParent.offsetTop + element.offsetHeight : 0,
                left: element ? element.offsetParent.offsetLeft + element.offsetParent.offsetWidth : 0
            });
        };
        this.closeDropdown = (id) => {
            this.setState({
                dropdownOpen: this.state.dropdownOpen.filter(x => x !== id)
            });
        };
        this.isUserLoggedIn = () => {
            const userToken = JSON.parse(localStorage.getItem("cw-profile-new"));
            return !!(userToken && userToken.token);
        };
        this.handleLoginClick = () => {
            this.props.openLoginModal();
        };
        this.renderMenuItem = (item) => {
            const { dropdownOpen, menuOpen } = this.state;
            let element = null;
            if (typeof window !== 'undefined' && window.document) {
                element = window.document.getElementById(item.id);
            }
            const classes = this.classes({
                [this.menuLink]: true,
                'active': this.isActive(item, element),
                'open': dropdownOpen.indexOf(item.id) !== -1,
                'with-sub-menu': element != null
            });
            const getStyle = (item) => {
                const index = this.state.dropdownOpen.indexOf(item.id);
                switch (index) {
                    case 0:
                        return {
                            top: element ? element.offsetTop + this.defaultOffsetTop : 0,
                            left: element ? element.offsetLeft : 0
                        };
                    case 1:
                        return { top: this.state.top, left: this.state.left };
                }
            };
            const getIcon = (item) => {
                return item.parent ? "arrowChild right" : "arrowParent down";
            };
            if (this.hasChildren(item.id)) {
                return (React.createElement("li", { id: item.id, key: item.id, className: classes, onClick: (e) => this.openDropdown(e, item) },
                    item.label,
                    " \u00A0 ",
                    React.createElement("i", { className: getIcon(item) }),
                    !menuOpen && dropdownOpen.indexOf(item.id) !== -1 &&
                        React.createElement(react_portal_1.Portal, null,
                            React.createElement("div", { className: "sub-menu-link", style: getStyle(item) }, this.renderChildren(item.id))),
                    menuOpen && this.renderChildren(item.id)));
            }
            return (React.createElement("a", { key: item.id, href: item.path, className: classes, target: item.openInNewWindow ? "_blank" : "" },
                item.label,
                this.renderChildren(item.id)));
        };
        this.state = {
            menuOpen: false,
            searchOpen: false,
            partners: [],
            dropdownOpen: [],
            partnerSupportsFilmGrail: false,
            domOffset: [],
            portal: null,
            top: 0,
            left: 0,
            showHumbergerIcon: false
        };
    }
    hasChildren(id) {
        const { menu } = this.props;
        return Boolean(menu.find(item => item.parent === id));
    }
    render() {
        const { menu, search, language } = this.props;
        const { menuOpen, searchOpen, partnerSupportsFilmGrail } = this.state;
        const headerMenu = menu.filter(item => item.parent === '' && item.place === 'header');
        const classes = this.classes({
            'is-menu-open': menuOpen,
            'is-search-open': searchOpen
        });
        return (React.createElement("header", { className: `Header ${classes}` },
            React.createElement("div", { className: "container" },
                React.createElement("a", { href: "/", className: "logo" },
                    React.createElement("img", { src: this.props.logo, alt: "" })),
                React.createElement("div", { className: "menu" },
                    React.createElement("div", { className: "menu-wrapper" },
                        partnerSupportsFilmGrail && menuOpen &&
                            React.createElement("div", { className: "container login-button-wrapper-mobile" }, this.isUserLoggedIn() ?
                                React.createElement("a", { href: "/min-side", className: "login-button login-button-mobile" }, " Min side ")
                                : React.createElement("div", { className: "login-button login-button-mobile", onClick: this.handleLoginClick }, "Logg inn")),
                        React.createElement("div", { className: `menu-items`, id: "menu-items" }, headerMenu.map(this.renderMenuItem))),
                    search.enabled &&
                        React.createElement("button", { className: "icon-button search-button", onClick: this.toggleSearch },
                            React.createElement("img", { src: icons_1.searchIcon, alt: "" })),
                    React.createElement("button", { className: "icon-button menu-button", onClick: this.toggleMenu },
                        React.createElement("img", { className: `menu-icon ${this.state.showHumbergerIcon ? 'show-humberger-icon' : 'hide-humberger-icon'}`, src: icons_1.hamburgerIcon, alt: "" }),
                        React.createElement("img", { className: "close-icon", src: icons_1.closeWhiteIcon, alt: "" })),
                    partnerSupportsFilmGrail && !menuOpen &&
                        React.createElement("div", { className: "login-button-wrapper-desktop" }, this.isUserLoggedIn() ?
                            React.createElement("a", { href: "/min-side", className: "login-button login-button-desktop" }, " Min side ")
                            : React.createElement("div", { className: "login-button login-button-desktop", onClick: this.handleLoginClick }, "Logg inn")),
                    language && language.enabled &&
                        React.createElement("a", { href: language.submitPath, className: "language-icon" },
                            React.createElement("img", { src: language.languageIcon, alt: "lang", className: "image" })))),
            search.enabled &&
                React.createElement("div", { className: "search" },
                    React.createElement("i", { className: "icon is-large" },
                        React.createElement("img", { src: icons_1.searchBigIcon, alt: "" })),
                    React.createElement("form", { action: search.submitPath, method: "GET" },
                        React.createElement("input", { name: "query", className: "input", placeholder: "S\u00F8k", type: "text", autoFocus: true })),
                    React.createElement("button", { className: "icon-button is-large", onClick: this.toggleSearch },
                        React.createElement("img", { src: icons_1.closeIcon, alt: "" })))));
    }
    renderChildren(parentId) {
        const { menu } = this.props;
        const items = menu.filter(item => item.parent === parentId);
        if (!items || items.length === 0) {
            return null;
        }
        return (React.createElement("ul", null, items.map(item => (React.createElement("li", { key: item.id }, this.renderMenuItem(item))))));
    }
    isActive(item, element) {
        if (typeof window === 'undefined') {
            return false;
        }
        if (item.path === "/") {
            return false;
        }
        return window.location.pathname.replace(/\/$/, '') === item.path.replace(/\/$/, '');
    }
    classes(classMap) {
        const classNames = [];
        Object.keys(classMap).forEach(key => {
            classMap[key] && classNames.push(key);
        });
        return classNames.join(' ');
    }
}
exports.Header = Header;



// WEBPACK FOOTER //
// ./src/layouts/components/Header.tsx